import { useLocation, Link } from 'react-router-dom';
import { Check, ArrowLeft } from 'lucide-react';
import Layout from '../components/Layout';
import Seo from '../components/Seo';

export default function Takk() {
  const params = new URLSearchParams(useLocation().search);
  const clinic = params.get('klinikk');
  const hasClinic = !!clinic;

  return (
    <Layout>
      <Seo title="Takk — Specialists.no" description="Takk for din forespørsel." noindex />
      <section className="bg-[#0A1F44] text-white py-24 lg:py-32 relative overflow-hidden min-h-[80vh] flex items-center">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#3B82F6]/15 rounded-full blur-[120px]" />
        <div className="relative max-w-3xl mx-auto px-4 text-center">
          <div className="w-20 h-20 mx-auto rounded-full bg-[#3B82F6] flex items-center justify-center mb-8 shadow-[0_0_60px_rgba(232,98,42,0.4)]">
            <Check size={36} strokeWidth={3} />
          </div>
          <h1 className="font-display text-4xl lg:text-5xl font-bold leading-tight mb-5">Takk for din forespørsel</h1>
          <p className="text-lg text-white/75 leading-relaxed max-w-2xl mx-auto">
            {hasClinic ? (
              <>Vi har mottatt din forespørsel og videresendt den til <span className="text-white font-semibold">{clinic}</span>. De vil kontakte deg innen 24 timer i åpningstid.</>
            ) : (
              <>Vi har mottatt din forespørsel og <span className="text-white font-semibold">finner den beste klinikken for deg</span>. Du blir kontaktet innen 24 timer i åpningstid.</>
            )}
          </p>
          <p className="mt-4 text-sm text-white/55">Du vil motta en bekreftelse på e-post kort tid.</p>
          <Link to="/" className="inline-flex items-center gap-2 mt-10 bg-[#3B82F6] hover:bg-[#2563EB] text-white px-7 py-3.5 rounded-full font-semibold transition-colors" data-testid="back-home">
            <ArrowLeft size={16} /> Tilbake til forsiden
          </Link>
        </div>
      </section>
    </Layout>
  );
}
